export const cardsData = [
  {
    id: 1,
    title: "麻豆传媒年度巨制《欲望都市》第二季重磅回归",
    desc: "全网独播，4K超清画质，每周五晚8点准时更新两集，会员抢先看全集。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20warm%20dramatic%20lighting%2C%20two%20characters%20in%20urban%20night%20setting%2C%20movie%20poster%20style%20with%20golden%20and%20crimson%20tones%2C%20professional%20cinematography%2C%20soft%20bokeh%20background%2C%20emotional%20atmosphere&width=800&height=500&seq=card-01&orientation=landscape",
    tag: "热播中",
    tagColor: "primary",
  },
  {
    id: 2,
    title: "国产悬疑巨作《迷局》全集上线，烧脑剧情获好评",
    desc: "豆瓣8.7分高分力作，12集精悍短剧，反转不断结局出人意料。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20thriller%20film%20scene%2C%20dark%20alley%20with%20rain%20and%20neon%20reflections%2C%20noir%20cinematography%2C%20suspenseful%20atmosphere%2C%20single%20silhouette%20under%20streetlight%2C%20cinematic%20composition%20with%20deep%20shadows&width=800&height=500&seq=card-02&orientation=landscape",
    tag: "高分推荐",
    tagColor: "accent",
  },
  {
    id: 3,
    title: "青春校园剧《盛夏光年》甜蜜上线，新生代演员阵容",
    desc: "改编自畅销小说，讲述一群大学生的校园故事，青春感满满引发共鸣。",
    image: "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20scene%2C%20sunlit%20university%20campus%20with%20cherry%20blossoms%2C%20young%20students%20walking%20together%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20and%20romantic%20atmosphere%2C%20soft%20pastel%20color%20palette&width=800&height=500&seq=card-03&orientation=landscape",
    tag: "新剧上线",
    tagColor: "primary",
  },
  {
    id: 4,
    title: "古装传奇《凤舞九天》播放量突破50亿，口碑持续发酵",
    desc: "制作精良的大女主古装剧，服化道考究，剧情紧凑不拖沓。",
    image: "https://readdy.ai/api/search-image?query=Historical%20Chinese%20costume%20drama%20scene%2C%20elegant%20female%20lead%20in%20traditional%20red%20hanfu%20dress%2C%20ancient%20palace%20courtyard%20with%20falling%20petals%2C%20ethereal%20golden%20lighting%2C%20dramatic%20composition%20with%20flowing%20silk%20fabrics&width=800&height=500&seq=card-04&orientation=landscape",
    tag: "现象级",
    tagColor: "accent",
  },
  {
    id: 5,
    title: "九色系列《都市夜话》第二季独家播映，尺度升级",
    desc: "聚焦都市男女情感话题，真实大胆的叙事风格引发全网热议讨论。",
    image: "https://readdy.ai/api/search-image?query=Urban%20nightlife%20cinematic%20scene%2C%20city%20skyline%20at%20twilight%2C%20modern%20apartment%20interior%20with%20warm%20ambient%20lighting%2C%20intimate%20atmosphere%2C%20film%20noir%20aesthetic%20with%20deep%20red%20and%20gold%20accents&width=800&height=500&seq=card-05&orientation=landscape",
    tag: "独家",
    tagColor: "primary",
  },
];

export const commentsData = [
  {
    id: 1,
    name: "夜色微凉",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20avatar%20portrait%20of%20a%20young%20woman%2C%20soft%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20neutral%20expression&width=80&height=80&seq=avatar-01&orientation=squarish",
    date: "2小时前",
    content: "这个平台真的太良心了！更新速度超级快，画质也清晰，已经推荐给身边所有朋友了。麻豆系列的质量越来越高了！",
    rating: 5,
    show: "欲望都市 第二季",
  },
  {
    id: 2,
    name: "追剧达人小王",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20avatar%20portrait%20of%20a%20young%20man%2C%20warm%20neutral%20tone%2C%20simple%20background%2C%20casual%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish",
    date: "5小时前",
    content: "找了好久终于找到一个不卡顿的高清影视站，《迷局》全集一口气看完，结局真的绝了！不用缓冲的体验太爽了。",
    rating: 5,
    show: "迷局",
  },
  {
    id: 3,
    name: "电影爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20avatar%20portrait%20of%20a%20middle%20aged%20person%2C%20warm%20lighting%2C%20simple%20studio%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-03&orientation=squarish",
    date: "1天前",
    content: "分类很全，国产剧、港剧、韩剧都有，而且没有乱七八糟的弹窗广告。希望平台越来越好，我会一直支持下去。",
    rating: 4,
    show: "凤舞九天",
  },
  {
    id: 4,
    name: "深夜观影人",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20avatar%20portrait%2C%20young%20adult%2C%20warm%20neutral%20tone%2C%20simple%20background%2C%20modern%20clean%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish",
    date: "2天前",
    content: "九色系列的内容越来越有深度了，不光是画面精美，剧情也很走心。《都市夜话》这一季的拍摄手法明显进步了。",
    rating: 5,
    show: "都市夜话 第二季",
  },
];

export const rankingData = [
  { id: 1, title: "欲望都市 第二季", category: "麻豆精品", hot: "987万", trend: "up", desc: "连续三周霸榜第一" },
  { id: 2, title: "迷局", category: "悬疑烧脑", hot: "856万", trend: "up", desc: "评分持续走高" },
  { id: 3, title: "凤舞九天", category: "古装传奇", hot: "821万", trend: "stable", desc: "总播放破50亿" },
  { id: 4, title: "盛夏光年", category: "青春校园", hot: "765万", trend: "up", desc: "新剧热度飙升" },
  { id: 5, title: "都市夜话 第二季", category: "九色系列", hot: "742万", trend: "up", desc: "话题讨论量暴增" },
  { id: 6, title: "荒野追踪", category: "动作冒险", hot: "698万", trend: "down", desc: "本周小幅回落" },
];

export const carouselData = [
  {
    id: 1,
    title: "麻豆传媒成立十周年特别企划",
    desc: "回顾十年经典作品，精选百部不容错过的殿堂级影片，限时免费开放观看。从早期的实验性短片到如今的院线级制作，见证国产精品影视的崛起之路。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20celebration%20scene%20with%20film%20reels%20and%20golden%20spotlights%2C%20elegant%20movie%20theater%20interior%2C%20luxurious%20red%20and%20gold%20decor%2C%20Hollywood%20style%20glamour%2C%20warm%20dramatic%20lighting%2C%20anniversary%20theme&width=1200&height=600&seq=carousel-01&orientation=landscape",
    badge: "十周年",
  },
  {
    id: 2,
    title: "2026夏季新剧前瞻：十部重磅剧集即将上线",
    desc: "涵盖悬疑、爱情、古装、都市等多种类型，多位一线演员加盟，制作水准全面升级。提前锁定你的夏季追剧清单，精彩不容错过。",
    image: "https://readdy.ai/api/search-image?query=Summer%20film%20festival%20scene%2C%20outdoor%20cinema%20at%20sunset%2C%20colorful%20movie%20posters%20displayed%2C%20warm%20golden%20hour%20atmosphere%2C%20festive%20and%20exciting%20vibe%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape",
    badge: "前瞻",
  },
  {
    id: 3,
    title: "九色品牌全新升级：更高画质、更深内容",
    desc: "全线支持4K HDR超高清播放，新增杜比全景声技术，为观众带来沉浸式观影体验。同时扩充内容团队，深耕原创精品路线。",
    image: "https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20ambient%20lighting%2C%20premium%20entertainment%20experience%2C%20warm%20and%20inviting%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape",
    badge: "升级",
  },
  {
    id: 4,
    title: "国产独立电影专区正式开放",
    desc: "携手百家独立制片方，为优秀国产独立电影提供展示窗口。扶持新锐导演，挖掘被埋没的好作品，让更多优秀影片被看见。",
    image: "https://readdy.ai/api/search-image?query=Independent%20film%20festival%20scene%2C%20art%20house%20cinema%20interior%20with%20film%20posters%2C%20creative%20atmosphere%2C%20warm%20vintage%20lighting%2C%20artistic%20and%20cultural%20vibe&width=1200&height=600&seq=carousel-04&orientation=landscape",
    badge: "新专区",
  },
  {
    id: 5,
    title: "观影有礼：每日签到领VIP，连续7天送月卡",
    desc: "回馈忠实观众，每日签到即可累计积分兑换VIP会员。连续签到7天直接赠送月度VIP，海量4K资源随心看。",
    image: "https://readdy.ai/api/search-image?query=Gift%20and%20reward%20celebration%20scene%2C%20golden%20confetti%20and%20sparkles%2C%20luxurious%20red%20and%20gold%20color%20palette%2C%20festive%20promotional%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20glow&width=1200&height=600&seq=carousel-05&orientation=landscape",
    badge: "福利",
  },
];

export const faqData = [
  {
    q: "91免费在线视频需要注册才能观看吗？",
    a: "大部分内容无需注册即可免费观看。注册会员后可享受4K超清画质、去广告、抢先看等专属权益，注册完全免费。",
  },
  {
    q: "为什么有些视频播放时会出现缓冲？",
    a: "我们提供多线路自动切换功能，当默认线路繁忙时会自动切换到备用线路，确保流畅播放。建议在网络环境良好时选择高清画质，以获得最佳观影体验。",
  },
  {
    q: "平台支持哪些设备观看？",
    a: "支持电脑、平板、手机等全终端观看。电脑端推荐使用Chrome或Edge浏览器，手机端可通过浏览器直接访问，也可下载我们的APP获得更佳体验。",
  },
  {
    q: "影片更新频率是怎样的？",
    a: "热门连载剧集每日更新，新上映影片48小时内上线。麻豆精品系列每周五定期更新，节假日会有特别专题策划和加更福利。",
  },
  {
    q: "是否有年龄限制或内容分级？",
    a: "平台对部分内容设有观看提示，建议未成年人请在家长指导下观看。我们倡导健康的观影文化，共同维护良好的网络环境。",
  },
  {
    q: "如何反馈播放问题或建议？",
    a: "您可以通过页面底部的「联系我们」区域提交反馈，也可以发送邮件至我们的客服邮箱。技术团队会在24小时内处理并回复您的建议。",
  },
];

export const contactData = {
  title: "联系我们 / 投稿合作",
  desc: "欢迎影视创作者、制片方与我们合作。如您有优秀的原创作品希望在本平台展示，或对平台有任何建议与反馈，请通过以下方式联系我们。我们珍视每一位创作者和观众的声音。",
  email: "contact@91freevideo.com",
  wechat: "91freevideo_official",
  qq: "1234567890",
};

export const indexData = [
  { id: 1, title: "麻豆精品专区", desc: "独家原创系列作品合集", icon: "ri-movie-2-line", count: 328 },
  { id: 2, title: "九色系列全集", desc: "热门话题影视专题", icon: "ri-palette-line", count: 156 },
  { id: 3, title: "国产剧大全", desc: "最新国产电视剧全集", icon: "ri-tv-2-line", count: 2048 },
  { id: 4, title: "高清电影库", desc: "万部高清电影在线看", icon: "ri-film-line", count: 5632 },
  { id: 5, title: "综艺娱乐", desc: "热门综艺节目更新", icon: "ri-emotion-laugh-line", count: 892 },
  { id: 6, title: "动漫番剧", desc: "日漫国漫精彩不断", icon: "ri-rocket-line", count: 1456 },
  { id: 7, title: "纪录片频道", desc: "精品纪录片深度内容", icon: "ri-earth-line", count: 478 },
];

export const updatesData = [
  { id: 1, date: "2026-07-31", title: "《欲望都市》第二季第8集更新上线", type: "update" },
  { id: 2, date: "2026-07-30", title: "悬疑剧《深渊回响》全集一次性放出", type: "new" },
  { id: 3, date: "2026-07-29", title: "平台服务器全面升级，加载速度提升30%", type: "system" },
  { id: 4, date: "2026-07-28", title: "九色系列《午夜航班》超前点映开启", type: "update" },
  { id: 5, date: "2026-07-27", title: "独立电影专区上线，首批50部作品入驻", type: "new" },
  { id: 6, date: "2026-07-26", title: "APP 3.0版本发布，全新界面体验升级", type: "system" },
  { id: 7, date: "2026-07-25", title: "《凤舞九天》大结局引发全网热议", type: "update" },
  { id: 8, date: "2026-07-24", title: "暑期档特别策划「爽剧马拉松」活动开启", type: "event" },
  { id: 9, date: "2026-07-23", title: "4K专区扩容，新增200部超高清影片", type: "system" },
];

export const aboutData = {
  title: "关于91免费在线视频",
  desc1: "91免费在线视频创立于2016年，是国内领先的高清影视内容聚合平台。六年来，我们始终致力于为观众提供海量优质影视资源，涵盖国产剧、电影、综艺、动漫、纪录片等全品类内容，累计服务超过千万用户。",
  desc2: "平台与麻豆传媒等多家知名内容方建立了深度合作关系，拥有丰富的独家资源和第一时间更新的热门剧集。我们坚持「高清不缓冲、免费不忽悠」的服务理念，通过持续的技术投入和内容建设，打造让观众放心、满意的在线观影平台。",
  desc3: "未来，我们将继续扩大内容库规模，提升播放技术体验，引入更多优质原创内容，努力成为每一位影视爱好者的首选观影目的地。",
};

export const topicsData = [
  { id: 1, name: "麻豆精品", count: "128万讨论", hot: true },
  { id: 2, name: "国产悬疑剧", count: "96万讨论", hot: true },
  { id: 3, name: "九色系列", count: "85万讨论", hot: true },
  { id: 4, name: "古装大女主", count: "73万讨论", hot: false },
  { id: 5, name: "短剧新风潮", count: "68万讨论", hot: true },
  { id: 6, name: "4K观影体验", count: "59万讨论", hot: false },
  { id: 7, name: "青春校园", count: "52万讨论", hot: false },
  { id: 8, name: "悬疑烧脑", count: "48万讨论", hot: false },
  { id: 9, name: "独立电影", count: "41万讨论", hot: true },
  { id: 10, name: "周末刷剧", count: "37万讨论", hot: false },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "4K超清画质",
    desc: "全场支持1080P至4K HDR高清播放，多码率自适应，根据网络环境智能切换最佳画质，画面细节纤毫毕现。",
  },
  {
    id: 2,
    icon: "ri-speed-up-line",
    title: "无需缓冲",
    desc: "全球CDN加速节点覆盖，智能多线路切换技术，确保播放流畅不卡顿。告别转圈等待，点击即看。",
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "纯净观影",
    desc: "无弹窗广告、无强制跳转，专注观影体验。绿色安全，不包含任何恶意代码，守护您的设备安全。",
  },
  {
    id: 4,
    icon: "ri-refresh-line",
    title: "极速更新",
    desc: "热门剧集同步更新，新片48小时内上线。7×24小时内容运营团队，不错过任何一部好片。",
  },
  {
    id: 5,
    icon: "ri-device-line",
    title: "全终端适配",
    desc: "电脑、平板、手机无缝切换观看。支持Chromecast投屏，大屏观影更震撼。APP端专享离线下载功能。",
  },
];

export const appData = {
  title: "随时随地，畅享高清影视",
  desc: "下载91免费在线视频APP，享离线缓存、画中画播放、个性化推荐等专属功能。手机看片更便捷，通勤路上也能追剧不停。",
  features: ["离线缓存随时看", "画中画悬浮播放", "智能推荐引擎", "夜间模式护眼", "倍速播放控制"],
};

export const mediaData = [
  {
    id: 1,
    title: "《深渊回响》官方预告片",
    desc: "一场意外揭开尘封十年的真相，谁能逃出深渊？",
    duration: "02:35",
    image: "https://readdy.ai/api/search-image?query=Dark%20thriller%20movie%20thumbnail%20style%2C%20mysterious%20figure%20in%20shadows%2C%20dramatic%20lighting%20with%20single%20light%20source%2C%20cinematic%20noir%20aesthetic%2C%20deep%20blacks%20and%20warm%20highlights&width=800&height=450&seq=media-01&orientation=landscape",
    views: "156万",
  },
  {
    id: 2,
    title: "《欲望都市》第二季精彩花絮",
    desc: "幕后拍摄趣事大公开，主演独家采访。",
    duration: "05:18",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20scene%2C%20camera%20crew%20at%20work%2C%20warm%20set%20lighting%2C%20professional%20filmmaking%20atmosphere%2C%20cinematic%20documentary%20style&width=800&height=450&seq=media-02&orientation=landscape",
    views: "203万",
  },
  {
    id: 3,
    title: "麻豆十周年回顾：经典作品混剪",
    desc: "十年光影，一瞬永恒。重温那些难忘的画面。",
    duration: "08:42",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20montage%20collage%20of%20film%20scenes%2C%20vintage%20film%20grain%20texture%2C%20golden%20nostalgic%20lighting%2C%20retro%20movie%20aesthetic%2C%20warm%20amber%20and%20sepia%20tones&width=800&height=450&seq=media-03&orientation=landscape",
    views: "389万",
  },
  {
    id: 4,
    title: "《凤舞九天》大结局片段",
    desc: "收视巅峰之作，千万观众共同见证。",
    duration: "04:15",
    image: "https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20climax%20scene%2C%20female%20lead%20in%20traditional%20red%20costume%2C%20dramatic%20palace%20setting%2C%20golden%20sunset%20lighting%2C%20emotional%20and%20powerful%20composition&width=800&height=450&seq=media-04&orientation=landscape",
    views: "562万",
  },
  {
    id: 5,
    title: "独立电影《归途》导演访谈",
    desc: "新人导演首部作品即获国际关注，创作心路分享。",
    duration: "12:08",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20interview%20setting%2C%20minimalist%20studio%20with%20warm%20lighting%2C%20creative%20professional%20atmosphere%2C%20cinematic%20documentary%20style%2C%20thoughtful%20and%20artistic%20mood&width=800&height=450&seq=media-05&orientation=landscape",
    views: "87万",
  },
];